export default __webpack_public_path__ + "static/media/blog-9.a2371974.jpg";